import React, { useEffect, useState, useRef } from "react"
import { Col } from "react-bootstrap"
import ExportToExcelCategories from "./tableComponents/ExportToExcelCategories"
import { sequence_Tabs } from "../../constant/Constants"
 
const SideNav = (props) => {
   const KeysCountRef = useRef([])
   const keys1Ref = useRef([])
   let hasOtherKeys = false
   const [diffCategories, setDiffCategories] = useState(props.diffCategories)
   const [activeButton, setActiveButton] = useState(null); // State to track the active button
 
   useEffect(() => {
      setDiffCategories(props.diffCategories)
   }, [props.diffCategories])
 
   let dataPartComp = props.resData
   const [partName] = useState(props.partName)
   const [showOther, setShowOther] = useState(false)
 
   for (const keys in dataPartComp) {
      if (dataPartComp[keys] === null) {
         delete dataPartComp[keys]
      }
   }
   const dataComplete = dataPartComp
 
   let keysSecondType = [
      "rdsites",
      "rohPlants",
      "performanceCharacteristic",
      "referenceDocuments",
      "relatedSpecifications",
      "alternates",
      "certification",
      "files",
      "lifecycleApprovalPowerview",
      "producingformula",
      "materialsAndComposition",
      "masterSpecifications",
      "ipClasses",
      "halbPlants",
      "stabilityDocument",
      "packagingCertificationsMaster",
      "relatedats",
      "startingmaterials",
      "security",
      "gpsAssessment",
      "substancesMaterials",
      "plants",
      "certificationsMaster",
      "substitution",
      "notes",
      "sapBomasFed",
      "billOfMaterials",
      "marketOfSale",
      "registrationDetails",
      "batteryCalculation",
      "cupArtworks",
      "billOfMaterialsCustomerUnit",
      "substitutesConsumerUnit",
      "bomMasterCunsumerUnit",
      "bomInnerPack",
      "transportUnit",
      "bomTransportUnit",
      "substitutesInnerPack",
      "batteryRollUp",
      "substitutes",
      "substitutesCustomerUnit",
      "substitutesTransportUnit",
      "bomMasterCustmerUnit",
      "bomMasterInnerPack",
      "substitutesMasterInnerPack",
      "substitutesMasterConsumerUnit",
      "bomConsumerUnit",
      "substitutesMastesConsumerUnit",
      "relatedACS",
      "relatedIAPS",
      "relatedSoftwareBuilds",
      "marketClearance"
   ]
   let keysThirdType = ["pqrViewManufacturer", "pqrSupplierView","baseCodeDetails","packingUnit"]
   let keysNotUsed = ["headerContent", "revision"]
   let keysFirstType = [
      "attributes",
      "weightCharacteristic",
      "storageTransportData",
      "notes",
      "marketClearance",
      "billofMaterials",
      "subStitutes",
      "ownership",
      "securityClasses",
      "organizations",
      "derivedParts",
      "sustainability",
      "batteryDetails",
      "chemicalMolecularProperties",
      "chemicalClassification",
      "detergentSurfactantProperties",
      "organizationsObject",
      "profileIdentification",
      "perfumeProperties",
      "physicalProperties",
      "weightsDimensionsObject",
      "storageTransportData"
   ]
   const revision = props.dataRevision
   const generateColumnData = (categoryData, category) => {
      if (
         keysFirstType.includes(category) ||
         keysSecondType.includes(category) ||
         keysThirdType.includes(category)
      ) {
         if (!categoryData || categoryData.length === 0) {
            return []
         }
         if (keysSecondType.includes(category) || keysThirdType.includes(category)) {
            const sampleData =
               categoryData.release && categoryData.release.length > 0
                  ? categoryData.release[0]
                  : categoryData.obsolete && categoryData.obsolete.length > 0
                  ? categoryData.obsolete[0]
                  : null
            if (!sampleData) {
               return []
            }
            return Object.keys(sampleData).map((key) => ({
               label: key,
               value: key,
            }))
         }
         const allKeys = Object.keys(categoryData[0])
         const columnData = allKeys.map((key) => ({
            label: key,
            value: key,
         }))
         columnData.push({ label: "Highlight", value: "Highlight" })
         return columnData
      }
   }
   const categories = Object.keys(dataComplete)
   categories.forEach((element) => {
      if (keysNotUsed.includes(element)) {
         categories.splice(categories.indexOf(element), 1)
      }
   })
   const categoryColumnData = categories.map((category) => {
      const categoryData = dataComplete[category]
 
      if (
         !categoryData ||
         (!Array.isArray(categoryData) &&
            !keysSecondType.includes(category) &&
            !keysThirdType.includes(category))
      ) {
         return { category, columnData: [] }
      }
      return {
         category,
         columnData: generateColumnData(categoryData, category),
      }
   })
 
   let sendData = []
   let sendKeysInObject = []
   const getSign = (value) => {
      const label = value.split("|")[1].trim().toLowerCase()
      return diffCategories.some(
         (category) => category.trim().toLowerCase() === label
      ) ? (
         <i className="fa fa-asterisk" style={{ color: "red" }}></i>
      ) : (
         <i className="fa fa-check" style={{ color: "green" }}></i>
      )
   }
   const getClassName = (value) => {
      const label = value.split("|")[1].trim().toLowerCase()
      return diffCategories.some((category) => category.trim().toLowerCase() === label)
         ? "unmatch"
         : "match"
   }
 
   const handleClicks = (val) => {
      setActiveButton(val)
      let keysOther =["23","24","25","26","27","28","29","30","31"]
      if(!keysOther.includes(val)){
         
         setShowOther(false)
      }
      KeysCountRef.current.forEach((key) => {
         const element = document.getElementById(key)
         if (element) {
            element.style.display = key === val ? "block" : "none"
         }
      })
   }
 
   const getNavLinks = () => {
      if (props.data) {
         const keys = []
         for (let k = 0; k < props.data.length; k++) {
            if (props.data[k].childNodes[0] != null) {
               keys[k] = props.data[k].id + "|" + props.data[k].childNodes[0].innerText
            } else {
               keys[k] = props.data[k].id + "|" + props.data[k].innerText
            }
         }
 
         const elements = keys.map((value, key) => {
            const id = value.split("|")[0]
            const label = value.split("|")[1]
 
            if (!KeysCountRef.current.includes(id)) {
               KeysCountRef.current.push(id)
            }
 
            return (
               <span key={key}>
                  <button
                     eventKey={value}
                     className={`${getClassName(value)} ${
                        activeButton === id ? "active-button" : ""
                     }`}
                     onClick={() => {
                        handleClicks(id)
                     }}
                     title={label}
                  >
                     {getSign(value)} &nbsp;
                     {label.length > 25 ? label.substring(0, 23) + "..." : label}
                  </button>
                  &nbsp;|&nbsp;
               </span>
            )
         })
 
         return elements
      }
   }
 
   const handleOtherClicks = () => {
      const firstValue = keys1Ref.current[0]?.split("|")[0]; 
      KeysCountRef.current.forEach((key) => {
         const element = document.getElementById(key)
         if(showOther==false){
            if (element) {
               setActiveButton(firstValue)
               element.style.display = key === firstValue ? "block" : "none"
            }
         }
         else{
            if (element) {
               setActiveButton("0")
               element.style.display = key == 0 ? "block" : "none"
            }
         }
         
      })
      setShowOther(!showOther);
   };
   const getNavLinksOther = (data) => {
      if (data) {
         keys1Ref.current = [] // Reset keys1Ref for each render
         for (let k = 0; k < data.length; k++) {
            if (data[k].childNodes[0] != null) {
               keys1Ref.current.push(data[k].id + "|" + data[k].childNodes[0].innerText)
            }
         }
         const elements = keys1Ref.current.map((value, key) => {
            const id = value.split("|")[0]
            const label = value.split("|")[1]
 
            if (!KeysCountRef.current.includes(id)) {
               KeysCountRef.current.push(id)
            }

            const keysOther = ["23", "24", "25", "26", "27", "28", "29", "30", "31"];
            hasOtherKeys = KeysCountRef.current.some((key) => keysOther.includes(key));
 
            return (
               <span key={key}>
                  <button
                     eventKey={value}
                     className={`${getClassName(value)} ${
                        activeButton === id ? "active-button" : ""
                     }`}
                     onClick={() => {
                        handleClicks(id)
                     }}
                     title={label}
                  >
                     {getSign(value)} &nbsp;
                     {label.length > 25 ? label.substring(0, 23) + "..." : label}
                  </button>
                  &nbsp;|&nbsp;
               </span>
            )
         })
         return elements
      }
      return null
   }

   const OtherTabsData = getNavLinksOther(props.dataOther)

   let categoryColumnSequenceData =[]
   let i = 0;
   sequence_Tabs.forEach((element) => {
      const matchingItem = categoryColumnData.find((item) => item.category === element)
      if (matchingItem) {
         categoryColumnSequenceData[i] = matchingItem
         i++;
      }
   }
)
   categoryColumnSequenceData.forEach(({ category, columnData }) => {
      if (!columnData || columnData.length === 0) {
         console.warn(`Skipping category with no column data: ${category}`)
         return
      }
      const keysInObject = columnData.map((col) => col.value)
      sendKeysInObject.push(keysInObject)

      let data = { [category]: dataComplete[category] }
      sendData.push(data)
   })
   return (
      <>
         <Col md="12" className="pickerContent">
            <div className="pickerNavStyle" style={{ marginBottom: "10px" }}>
               <div style={{ display: "flex" }}>
                  <span>
                     {getNavLinks()}
                     {hasOtherKeys && ( 
                        <>
                           <button className="OtherButton" onClick={handleOtherClicks}>
                              &nbsp; Others
                           </button>
                           |&nbsp;
                        </>
                     )}
                     <div>
                     {showOther && <span>{OtherTabsData}</span>}
                     </div>
                  </span>
                  <div style={{ justifyContent: "end" }}>
                     <ExportToExcelCategories
                        data={sendData}
                        revision={revision}
                        columnData={categoryColumnSequenceData}
                        keysInObject={sendKeysInObject} 
                        keysFirstType={keysFirstType}
                        keysSecondType={keysSecondType}
                        keysThirdType={keysThirdType}
                        keysNotUsed={keysNotUsed}
                        partName={partName}
                     />
                  </div>
               </div>
            </div>
         </Col>
      </>
   )
}
 
export default SideNav

